import React, { useEffect, useRef } from "react";
import { Container, SlideContainer, StepsWrapper } from "./styles";
// import { gsap } from "gsap";
// import { ScrollTrigger } from "gsap/ScrollTrigger";
import { addToRefs } from "utils";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import { react_slick_settings } from "component/utils";
import AOS from "aos";
import "aos/dist/aos.css";

// gsap.registerPlugin(ScrollTrigger);

function Index({ header, title, bg, cardDetails, id = "" }) {
  const cardRef = useRef([]);
  cardRef.current = [];

  useEffect(() => {
    // cardRef.current.forEach((el, index) => {
    //   gsap.from(el, {
    //     ease: "none",
    //     opacity: 0,
    //     scrollTrigger:
    //     {
    //       id: `card-${index}`,
    //       trigger: el,
    //       start: "20px 80%",
    //       toggleActions: "play none restart reverse"
    //       // markers: true,
    //     }
    //   });
    // });
    AOS.init();
  }, []);

  return (
    <>
      <Container bg={bg} data-id={id}>
        <div className="wrapper">
          <div className="header">
            <span>{header}</span>
            <p className="title">{title}</p>
          </div>
          <div className="cards">
            {cardDetails?.map(({ step, value, desc, icon, bg }, index) => (
              <div className="card" key={step + value + index} ref={(el) => addToRefs(el, cardRef)}>
                <div className="card-content" data-aos="fade-right" data-aos-duration="800">
                  <div className="svg-wrapper" style={{ background: bg }}>
                    {icon}
                  </div>
                  <span>{step}</span>
                  <p className="step-text">{value}</p>
                  <p>{desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </Container>
      <SlideContainer bg={bg} data-id={id}>
        <div className="slide-container">
          <div className="header">
            <span>{header}</span>
            <p className="title">{title}</p>
          </div>
          <Slider {...react_slick_settings} className="cards">
            {cardDetails?.map(({ step, value, desc, icon, bg }, index) => (
              <StepsWrapper key={step + value + index}>
                <div
                  className="card"
                  key={step + value + index}
                  ref={(el) => addToRefs(el, cardRef)}
                >
                  <div className="card-content">
                    <div className="svg-wrapper" style={{ background: bg }}>
                      {icon}
                    </div>
                    <span>{step}</span>
                    <p className="step-text">{value}</p>
                    <p>{desc}</p>
                  </div>
                </div>
              </StepsWrapper>
            ))}
          </Slider>
        </div>
      </SlideContainer>
    </>
  );
}

export default Index;
